// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__BwJ_r","menu-list":"style_menu-list__ugdag","menu-empty":"style_menu-empty__WEHI3"};